export default "__VITE_ASSET__Cfwcoml1__"